import React, { Component } from 'react';
import filesaver from 'file-saver';
import DocumentCard from 'Components/cards/DocumentCard';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { getTranslations } from '../configStructure';
import DualDateInput from 'Components/forms/DualDateInput';
import { getSummaryReport, downloadSummaryReport } from "Apis/userActivityManagerApi.js"

import './HourlySummary.scss';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setSearchOpenFlag } from 'Actions/drawerAction';

const translations = getTranslations();
export class HourlySummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportData: {},
      currentValues: '',
      isLoading: true,
    };
    this.attachBindings();
  }

  attachBindings() {
    this.getReportData = this.getReportData.bind(this);
    this.download = this.download.bind(this);
    this.getDocumentCard = this.getDocumentCard.bind(this);
  }

  componentDidMount() {
    this.setToday();
    this.getReportData();
  }

  setToday = () => {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();
    today = mm + '/' + dd + '/' + yyyy;
    this.setState({ today });
  }

  getReportData(startDate, endDate) {
    this.setState({
      isLoading: true,
    });
    return getSummaryReport("Hourly Productivity Report", startDate, endDate)
      .then((apiResponse) => {
        const reportData = apiResponse.data;
        this.setState({
          reportData: reportData,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({ reportData: [], isLoading: false });
        console.log('Error Occured while fetching report data', error);
      });

  }

  download(document) {
    downloadSummaryReport("Hourly Productivity Report", document.fileName)
      .then((response) => {
        filesaver.saveAs(response, document.fileName);
      })
      .catch((error) => {
        console.log('Error Occured while Downloading', error);
      });
  }

  getDocumentCard(reportName, reports) {

    return (
      <div className="card-list">
        <h2 className="card-category">
          <b>
            {reportName}
          </b>
        </h2>{
          reports.map((document, index) => {
            return (
              <DocumentCard
                key={index}
                title={document.fileName}
                primaryAction={() => {
                  this.download(document);
                }}
                primaryActionText="Download"
                secondaryOptions={[]}
                document={document}
              >
                <span>
                  <span className="document-generated">
                    Generated
                  </span>
                    &nbsp;
                  <span className="document-creation-date">
                    {document.fileCreatedDate.split(" ")[0]}
                  </span>
                  &nbsp;
                  &nbsp;
                  <span className="document-generated">
                    Size
                  </span>
                  &nbsp;
                  <span className="document-creation-date">
                    {document.size != null ? `${document.size} KB` : "--"}
                  </span>
                </span>
              </DocumentCard>
            );
          })
        }
      </div>
    );
  }

  get reportCards() {
    const parseDailyReportCategories = (
      <div>
        <span className="documents">
          {
            this.getDocumentCard("",
              this.state.reportData != undefined ?
                this.state.reportData : [])
          }
        </span>
      </div>
    )

    return (
      <section className="reports-container">
        <div className={this.props.isSearchActive ? 'main-content--header secondary-header' : "main-content--header "} style={{ zIndex: 2 }}>
          <h1> Hourly Summary Productivity Report </h1>
        </div>
        <span className="Calender" style={{marginTop: this.props.isSearchActive ? "20px" : "84px"}}>
          <div className="calenderBox">
            {/* <YearMonthPicker
              id="reportMonth"
              key="reportMonth"
              title="REPORT MONTH"
              handleMonthChange={this.handleMonthChange}
              currentValues={`${this.state.currentValues}`}
            /> */}

            <DualDateInput
              id={"hourlrySummeryReport"}
              key={"hourlrySummeryReport"}
              onApply={this.handleDualDates}
              title="REPORT HOUR"
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              dateFormat={"MM/DD/YYYY"}
              translations={translations.dates}
              defaultSelect={false}
              isDefaultDateSelected={false}
              updatedId={"dualDateInput"}
              isMerchantUser={true}
              maxDate={this.state.today}
              // exactDate={true}
            />
          </div>
        </span>
        { parseDailyReportCategories }
      </section >
    );
  }

  handleDualDates = (id, dualValues) => {
    let { startDate, endDate } = dualValues;
    this.setState({ startDate, endDate })
    this.getReportData(startDate, endDate);
  }

  render() {
    return (
      <section className="reports-container">
        {
          (!this.state.isLoading) ? (
            this.reportCards) :
            (
              this.state.isLoading && (
                <div className="ball-sync-loader loader" style={{ height: 200, backgroundColor: 'white' }}>
                  <BVLoader20 />
                </div>
              )
            )
        }
      </section>
    );
  }
}

HourlySummary.propTypes = {

};

HourlySummary.defaultProps = {

};

const mapStateToProps = (state) => ({
  isSearchActive: state.appSearch.isSearchActive,
});

const mapDispatchToProps = (dispatch) => {
  return {
      setSearchOpenFlag: (isSearchActive) => {
          dispatch(setSearchOpenFlag(isSearchActive));
      },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HourlySummary));
